import { useCallback, useState } from 'react'
import NoneAnchor from 'components/NoneAnchor'
import PropTypes from 'prop-types'
import { batch, useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { DashboardTypes } from 'features/Codes'
import Icon from 'components/Icon'
import { setType } from 'features/dashboard/dashboardCommonSlice'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'
import { DashboardTypeNames } from 'features/dashboard/utils/hooks/useDashboardTypeName'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import {
  exitEditable,
  keywordTableActions,
} from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const TabIcons = {
  [DashboardTypes.CAMPAIGN]: 'campaign',
  [DashboardTypes.AD_GROUP]: 'adgroup',
  [DashboardTypes.KEYWORD]: 'keyword',
  [DashboardTypes.CREATIVE]: 'material',
}

const TabItem = ({ type }) => {
  const dispatch = useDispatch()
  const {
    common: { type: tab },
    table: {
      campaignTable: {
        selectedIds: campaignSelectedIds,
        isLoading: campaignLoading,
      },
      adGroupTable: {
        selectedIds: adGroupSelectedIds,
        isLoading: adGroupLoading,
      },
      keywordTable: { isLoading: keywordLoading, editable },
      creativeTable: { isLoading: creativeLoading },
    },
  } = useSelector(state => state.dashboard)
  const { selectedIds } = useDashboardTableSelector(type)
  const { setSelectedIds } = useDashboardTableActions(type)
  const [hover, setHover] = useState(false)
  const currentCount = selectedIds.length
  const campaignCount = campaignSelectedIds.length
  const adGroupCount = adGroupSelectedIds.length
  const active = type === tab
  const name = DashboardTypeNames[type]
  const isLoading =
    campaignLoading || adGroupLoading || keywordLoading || creativeLoading
  const handleTabClick = useCallback(() => {
    if (isLoading) return
    dispatch(setType(type))
    if (type !== DashboardTypes.KEYWORD && editable) {
      dispatch(exitEditable())
    }
  }, [dispatch, editable, isLoading, type])
  const handleCountClick = useCallback(() => {
    if (editable) return
    batch(() => {
      dispatch(setSelectedIds([]))
      if (type === DashboardTypes.CAMPAIGN) {
        dispatch(adGroupTableActions.setPage(0))
        dispatch(keywordTableActions.setPage(0))
        dispatch(creativeTableActions.setPage(0))
      } else if (type === DashboardTypes.AD_GROUP) {
        dispatch(keywordTableActions.setPage(0))
        dispatch(creativeTableActions.setPage(0))
      }
    })
  }, [dispatch, editable, setSelectedIds, type])
  return (
    <li
      className={classNames({ on: active || hover })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}>
      <NoneAnchor
        className="link_tab"
        style={isLoading ? { pointerEvents: 'none' } : undefined}
        onClick={handleTabClick}>
        <Icon name={TabIcons[type]} />
        {name}
        {currentCount === 0 &&
          type === DashboardTypes.AD_GROUP &&
          campaignSelectedIds.length > 0 && (
            <span className="desc_tabsub">- 캠페인 {campaignCount}개</span>
          )}
        {currentCount === 0 &&
          (type === DashboardTypes.KEYWORD ||
            type === DashboardTypes.CREATIVE) &&
          (adGroupCount > 0 || campaignCount > 0) && (
            <span className="desc_tabsub">
              {adGroupCount > 0
                ? `- 광고그룹 ${adGroupCount}개`
                : `- 캠페인 ${campaignCount}개`}
            </span>
          )}
      </NoneAnchor>
      {currentCount > 0 && (
        <NoneAnchor className="btn_tabnum" onClick={handleCountClick}>
          {currentCount}개<span className="ico_comm ico_close">닫기</span>
        </NoneAnchor>
      )}
    </li>
  )
}
TabItem.propTypes = {
  type: PropTypes.string,
}
const DashboardTab = () => (
  <div className="dashboard_tab">
    <strong className="screen_out">데이터 테이블 탭 리스트</strong>
    <ul className="tab_dashboard">
      <TabItem type={DashboardTypes.CAMPAIGN} />
      <TabItem type={DashboardTypes.AD_GROUP} />
      <TabItem type={DashboardTypes.KEYWORD} />
      <TabItem type={DashboardTypes.CREATIVE} />
    </ul>
  </div>
)
export default DashboardTab
